var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import AddSubjectLabelCategoryDialog from '@/views/SubjectLabelCategories/AddSubjectLabelCategoryDialog';
import ErrorHandler from '@/support/ErrorHandler';
import { SubjectLabelCategory } from '@/models/SubjectLabelCategory';
let SubjectLabelCategories = class SubjectLabelCategories extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'SubjectLabelCategories';
        this.selected = [];
        this.isCreatingOrEditingCategory = false;
        this.selectedCategory = null;
    }
    onClickCreate() {
        this.selectedCategory = null;
        this.isCreatingOrEditingCategory = true;
    }
    getSubjectLabelCategoryAreaCount(areas) {
        return areas.length || 0;
    }
    refreshDataTable() {
        this.isCreatingOrEditingCategory = false;
        this.refreshFilterStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
    async refreshFilterStore() {
        await new SubjectLabelCategory()
            .all()
            .then((subjectLabelCategories) => {
            const mutatedSubjectLabelCategories = [];
            const payload = {};
            subjectLabelCategories.forEach((subjectLabelCategory) => {
                mutatedSubjectLabelCategories.push({
                    value: subjectLabelCategory.id,
                    text: subjectLabelCategory.getFilterLabel(),
                });
            });
            payload.SubjectLabelCategory = mutatedSubjectLabelCategories;
            this.$store.dispatch('updateFilters', payload);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('Tag category', 1),
                plural: this.$tc('Tag categories', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'label',
                    editable: false,
                    changed: false,
                    slot: 'name',
                },
                {
                    text: this.$t('Amount of areas'),
                    slot: 'subjects',
                    value: 'subjects',
                    editable: false,
                    changed: false,
                },
            ],
            actions: [
                {
                    type: 'edit',
                    label: 'edit',
                    icon: 'remove_red_eye',
                    visible: true,
                    action: (vm, subjectLabelCategory) => {
                        if (!subjectLabelCategory || !subjectLabelCategory.id) {
                            return;
                        }
                        this.$router.push({ name: 'subject-label-category.index', params: { id: subjectLabelCategory.id } });
                    },
                },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    visible: (vm, subjectLabelCategory) => {
                        return subjectLabelCategory && subjectLabelCategory.label !== 'Algemeen';
                    },
                    action: (vm, subjectLabelCategory) => {
                        this.selectedCategory = subjectLabelCategory;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            model: new SubjectLabelCategory().include('subjects'),
        };
    }
    get dialogOptions() {
        const category = this.selectedCategory;
        return {
            title: this.$tc('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: category.label }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!category) {
                            return;
                        }
                        category
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedCategory = null;
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedCategory = null;
                    },
                },
            },
        };
    }
};
SubjectLabelCategories = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddSubjectLabelCategoryDialog,
        },
    })
], SubjectLabelCategories);
export default SubjectLabelCategories;
